// Floating back-to-top button with a thin ring that fills as the page scrolls.
// Appears after scrolling past ~1.5 screens; lifts above the sticky add-to-cart bar when that bar is showing.
class BackToTop extends HTMLElement {
  #ac;
  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const ring = this.querySelector('[data-ring]');
    const length = ring ? ring.getTotalLength() : 0;
    if (ring) ring.style.strokeDasharray = `${length}`;
    let frame = 0;

    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const y = window.scrollY;
        this.toggleAttribute('data-visible', y > window.innerHeight * 1.5);
        if (ring) ring.style.strokeDashoffset = `${length * (1 - (max > 0 ? Math.min(1, y / max) : 0))}`;
        const sticky = document.querySelector('s-sticky-atc[data-visible]');
        this.style.setProperty('--btt-lift', sticky ? `${sticky.offsetHeight}px` : '0px');
      });
    };

    this.querySelector('button')?.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      document.querySelector('#MainContent, main')?.focus?.({ preventScroll: true });
    }, { signal });
    window.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { signal });
    update();
  }
  disconnectedCallback() {
    this.#ac?.abort();
  }
}
if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', BackToTop);
